module.exports = __webpack_public_path__ + "static/media/OtherServices.36e22808.svg";